import http from "./http_common";

class LabOrderService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => (key && payload[key] ? key + "=" + payload[key] : ""))
      .join("&");
  }

  GetLabList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/userLabMap/list/filter?${queryString}`);
  }

  getLabReportsData(payload) {
    const queryString = this.queryString(payload);
    return http.get(`labTestOrderResult/getall-labresults?${queryString}`);
  }

  GetLabTestOrderDtl(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/labTestOrderDtl/prescriptionforlab?${queryString}`);
  }

  getLabOrdersList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/labTestOrderHdr/get/list/lab?${queryString}`);
  }

  getLabOrder(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/labTestOrderDtl/list/filter?${queryString}`);
  }
  opOrderDetails(payload){
    const queryString = this.queryString(payload);
    return http.get(`/OpOrderDtl/list/filter?${queryString}`);
  }

  LabListSave(payload) {
    return http.post(`/labTestOrderHdr/save`, payload);
  }

  LabListGet(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/labTestOrderHdr/list/filter?${queryString}`);
  }

  LabReportUpload(payload) {
    return http.post(`/labTestOrderResult/save`, payload);
  }

  LabReportUploadGet(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/labTestOrderResult/list/filter?${queryString}`);
  }

  OpOrdersList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/OpOrderHdr/list/filter?${queryString}`);
  }

  inclinicReportUpload(payload){
    return http.put(`/labTestOrderResult/update/${payload.id}`, payload);
  }

  UpdateLabStatus(payload) {
    return http.put(`/patientAppointment/update/labPrescriptionStatus`, payload);
  }

  labOrderCancel(payload) {
    return http.put('/labTestOrderHdr/cancel/lab-orders', payload);
  }

  inclinicOrderValueOrFileUpload(payload){
    return http.post('/labTestOrderResult/save',payload);
  }

  updateInclinicOrderValueOrFileUpload(payload){
    return http.put(`/labTestOrderResult/update/${payload.id}`,payload);
  }

  inclinicFileBatchUpload(payload){
    return http.post('/labTestOrderResult/BatchSave',payload);
  }
  
}
export default new LabOrderService();
